import * as React from "react";
import { House, RefreshCw, Landmark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const services = [{
  title: "AI Consultation",
  description: "Identify high-value workflows and strategic opportunities where AI can drive immediate ROI for your business.",
  icon: House,
  iconBg: "bg-chart-1",
  link: "/ServicesPage"
}, {
  title: "AI Enablement",
  description: "Empower your marketing and operations teams with the skills and tools needed to master AI-driven productivity.",
  icon: RefreshCw,
  iconBg: "bg-chart-2",
  link: "/ServicesPage"
}, {
  title: "Workflow Automation",
  description: "Eliminate repetitive manual work by building intelligent, automated systems that scale with your growth.",
  icon: Landmark,
  iconBg: "bg-chart-3",
  link: "/ServicesPage"
}];
export default function OurCoreExpertise() {
  return <section data-section-id="256172" id="our-core-expertise" className="bg-card py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16 mt-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="relative flex flex-col h-full border-border/50 shadow-sm hover:shadow-lg hover:border-chart-1 transition-all duration-300 pt-8 mt-8 bg-background">
                <div className={`absolute -top-10 left-6 flex h-20 w-20 items-center justify-center rounded-lg shadow-md text-white ${service.iconBg}`}>
                  <Icon className="h-10 w-10" strokeWidth={1.5} />
                </div>
                <CardHeader className="pt-6 pb-4">
                  <CardTitle className="font-default text-2xl text-foreground font-semibold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-card-foreground/80 leading-relaxed font-default">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pb-8">
                  <Button asChild className="bg-chart-1 hover:bg-chart-2 text-white border-none shadow-sm transition-colors duration-200">
                    <Link to={service.link}>Learn More</Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}